import React from 'react';
import { Input,Button,Modal, Form } from 'semantic-ui-react';
import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag';
import {flowRight as compose} from 'lodash';
import {withFormik} from 'formik';
import _ from 'lodash';

const AddChannelModal = ({
    open,
    onClose,
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  }) => (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>Add Channel</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <Input
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              name="name"
              fluid
              placeholder="Channel name"
            />
          </Form.Field>
          <Form.Group widths="equal">
            <Button disabled={isSubmitting} onClick={handleSubmit} fluid>
              Create Channel
            </Button>
            <Button disabled={isSubmitting} fluid onClick={onClose}>
              Cancel
            </Button>
          </Form.Group>
        </Form>
      </Modal.Content>
    </Modal>
  );
  
const createChannelMutation = gql`
    mutation($teamId: Int!, $name: String!) {
      createChannel(teamId: $teamId, name: $name){
        ok
        channel{
          id
          name 
        }
      }
    }
  `;
  const allTeamsQuery=gql`
  {
      me{
          id
          username
          teams{
              id
              name
              admin
              channels{
                  id
                  name
              }
          }
      }
  }
  `;
  export default compose(
    graphql(createChannelMutation),
    withFormik({
      mapPropsToValues: () => ({ name: '' }),
      handleSubmit: async (values, { props: { onClose, teamId, mutate }, setSubmitting }) => {
        
        values.name=values.name.trim();
        if(values.name.length==0) {return}

        await mutate({
          variables: { teamId, name: values.name },
          update:(store,{data:{createChannel}})=>{
            const {ok,channel}=createChannel;
            if(!ok){
              return;
            }
            // reading cached value from browser
            let data=store.readQuery({query:allTeamsQuery});
            let newData=_.cloneDeep(data);
 
            const ind=_.findIndex(newData.me.teams,['id',teamId]);
            try{
            newData.me.teams[ind].channels.push(channel);
            }catch(err){
              console.log(err);
              return;
            }
        
            // writting to cached value
            store.writeQuery({query:allTeamsQuery,data:newData});
          }, 
        });
        
        onClose();
        setSubmitting(false);
      },
    }),
  )(AddChannelModal);
